module.exports = __webpack_public_path__ + "img/benefit-card-3-mobile.223effe6.png";